































import { Component, Vue } from "vue-property-decorator";
import { auth, dangisWiki as wiki } from "@/config/host.config";
import { IWikiObject, IWikiCategory } from "@/@types/wiki/wiki-object";
import { IGuest } from "@/@types/admin/guest/user";

import ButtonBack from "@/components/buttons/button-back.vue";
import Inputseartch from "@/components/app/search/input-search.vue";
import HistoryWikiGraph from "@/components/graphs/history-wiki-graph.vue";

@Component({
  name: "WikiHistory",
  components: { ButtonBack, HistoryWikiGraph, Inputseartch },
})
export default class WikiHistory extends Vue {
  wikiList: Array<IWikiObject> = [];
  categorys: Array<IWikiCategory> = [];
  users: Array<IGuest> = [];
  id = "";
  seartch = "";

  get wikis(): Array<IWikiObject> {
    const filterKey = this.seartch && this.seartch.toLowerCase();
    return this.wikiList.filter((item) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(filterKey.toLowerCase()) > -1
      );
    });
  }

  get wiki(): IWikiObject | null {
    const wiki = this.wikiList.find((el) => el._id == this.id);
    return wiki ? wiki : null;
  }

  isError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  async createWikiList(): Promise<void> {
    const url: string = wiki.getAllDots;
    const params = { "match[deleted][value]": false, history: true };

    try {
      const res = await this.$axios.get(url, { params });
      if (res.status === 200) this.wikiList = res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getUsers(): Promise<void> {
    const uri = auth.getUser;
    const params = { history: true };

    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.users = res.data;
    } catch (e) {
      console.log(e);
    }
  }

  async changeWikiObj(data: Partial<IWikiObject>): Promise<void> {
    if (!this.wiki) return this.isError();
    const uri = wiki.mainAPI + "/" + this.wiki._id;
    try {
      const res = await this.$axios.put(uri, data);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (!this.wiki) this.createWikiList();
        const id = this.wiki._id;
        const i = this.wikiList.findIndex((el) => el._id == id);
        if (i < 0) return this.createWikiList();
        this.$set(this.wikiList, i, res.data);
      }
    } catch (e) {
      console.error(e);
      this.isError();
    }
  }

  async getWikiCategorys(): Promise<void> {
    const uri = wiki.categorys.main;
    const params = { "match[deleted][value]": false };
    try {
      const catres = await this.$axios.get(uri, { params });
      if (catres.status === 200) this.categorys = catres.data;
    } catch (error) {
      console.error(error);
    }
  }

  mounted(): void {
    this.createWikiList();
    this.getUsers();
    this.getWikiCategorys();
  }
}
